import {
  ADD_ITEMS_TO_SHOPPING_CART,
  DELETE_ITEM_TO_SHOPPING_CART,
  ADD_PERSONAL_DATA_TO_SHOPPING_CART,
  CHANGE_IS_GITFT,
  ADD_NOTES,
  USE_CRIS_DATA,
  RESET_CART,
  DELETE_ITEM_TO_SHOPPING_CART_BY_ID,
} from 'constants/shopping-cart';

const initialState = {
  data: [],
};

export const addItemsShoppingCartReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case ADD_ITEMS_TO_SHOPPING_CART: {
      return {
        ...state,
        data: [...state.data, payload],
      };
    }
    case ADD_PERSONAL_DATA_TO_SHOPPING_CART: {
      const { index, membersList } = payload;
      /* eslint-disable */
      const result = state.data.filter((obj) => obj.id === index);
      result.map((res) => res.membersList = membersList);

      return {
        ...state,
        data: [...state.data],
      };
    }
    case DELETE_ITEM_TO_SHOPPING_CART: {
      state.data.splice(payload, 1);

      return {
        ...state,
        data: [...state.data],
      };
    }
    case CHANGE_IS_GITFT: {
      const { index, value } = payload;
      /* eslint-disable */
      state.data[index].isGift = value;

      return {
        ...state,
        data: [...state.data],
      };
    }
    case ADD_NOTES: {
      const { index, notes } = payload;
      /* eslint-disable */
      state.data[index].notes = notes;

      return {
        ...state,
        data: [...state.data],
      };
    }
    case USE_CRIS_DATA: {
      const { index, value } = payload;
      /* eslint-disable */
      state.data[index].useCrisData = value;

      return {
        ...state,
        data: [...state.data],
      };
    }
    case RESET_CART: {
      return initialState;
    }
    case DELETE_ITEM_TO_SHOPPING_CART_BY_ID: {
      const newState = state.data.filter((exp) => exp.id !== payload);
      return {
        data: newState,
      };
    }
    default:
      return state;
  }
};
